<div class="audio-wrapper">
  <audio  #audioRef [src]="currentImage.modal.extUrl" class="audio" controls loop></audio>
</div>
